exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f7d360b4] .el-dialog .el-input-number{width:280px}", ""]);

// exports
